import { Injectable } from "@angular/core";
import * as Highcharts from "highcharts";
import { environment } from "../../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { DatePipe, DecimalPipe } from "@angular/common";

Highcharts.setOptions({
  global: {
    useUTC: true,
    timezoneOffset: 300
  }
});
@Injectable({
  providedIn: "root",
})
export class HighchartOptionsService {


  constructor(
    private translate: TranslateService,
    private datePipe: DatePipe,
    private decimalPipe: DecimalPipe
  ) { }

  lineQoSChart = (
    filename: string,
    data: any,
    categories: any[],
    colors: any,
    title: string,
    subtitle: string,
    dataLabelsFormat: string,
    tooltipPointFormat: string,
    isStacked: boolean,
    showLegend: boolean,
    yTitleThroughput: string = '',
    yTitleDownTime: string = '',
    yTitleLatency: string = '',
    plotOptions?: any) => {
    return {
      exporting: {
        filename
      },
      chart: {
        type: 'line',
        borderColor: '#ddd',
        borderWidth: 1
      },
      colors: Highcharts.getOptions().colors,
      plotOptions: {
        series: {
          dataLabels: {
            enabled: false
          }
        }
      },
      tooltip: {
        shared: true,
        valueDecimals: 2
      },
      xAxis: {
        type: 'datetime',
        crosshair: true
      },
      yAxis: [{
        labels: {
          format: '{value} kbps',
          style: {
            color: Highcharts.getOptions().colors[2]
          }
        },
        title: {
          text: yTitleThroughput,
          style: {
            color: Highcharts.getOptions().colors[2]
          }
        },
        opposite: true,
        alignTicks: false

      }, {
        gridLineWidth: 0,
        labels: {
          format: '{value} s',
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        title: {
          text: yTitleDownTime,
          style: {
            color: Highcharts.getOptions().colors[0]
          }
        },
        alignTicks: false

      }, {
        gridLineWidth: 0,
        title: {
          text: yTitleLatency,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        labels: {
          format: '{value} ms',
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        },
        opposite: true
      }],
      title: {
        text: title
      },
      legend: {
        labelFormat: '{name}',
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'bottom'
      },
      series: data
    }
  }

  lineChart = (
    filename: string,
    data: any[],
    categories: any[],
    colors: any,
    title: string,
    subtitle: string,
    dataLabelsFormat: string,
    tooltipPointFormat: string,
    isStacked: boolean,
    showLegend: boolean,
    yTitle: string = '',
    plotOptions?: any
  ) => {
    return {
      exporting: {
        filename
      },
      chart: {
        type: "line",
        borderColor: "#ddd",
        borderWidth: 1,
      },
      colors,
      plotOptions: plotOptions || (isStacked
        ? {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              format: "{point.y:,.2f}",
            },
          },
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.y:,.2f}",
            },
          },
        }
        : {
          column: {
            dataLabels: {
              enabled: true,
              format: "{point.y}",
            },
          },
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.y}",
            },
          },
        }),
      xAxis: {
        categories,
      },
      yAxis: {
        title: {
          text: yTitle
        }
      },
      stackLabels: {
        enabled: true,
      },
      legend: showLegend
        ? {
          labelFormat: dataLabelsFormat,
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
        }
        : {
          enabled: false,
        },
      title: {
        useHTML: true,
        text: title,
      },
      series: data,
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: tooltipPointFormat,
        shared: true,
      },
    };
  };

  pieChart = (
    filename: string,
    data: any[],
    colors: any,
    title: string,
    subtitle: string,
    dataLabelsFormat: string,
    tooltipPointFormat: string
  ): Highcharts.Options => {
    return {
      exporting: {
        filename
      },
      chart: {
        type: "pie",
        borderColor: "#ddd",
        borderWidth: 1,
      },
      colors,
      credits: {
        enabled: false,
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          dataLabels: {
            enabled: true,
            format: dataLabelsFormat,
            showInLegend: true,
            style: {
              color:
                (Highcharts.theme && Highcharts.theme.contrastTextColor) ||
                "black",
            },
          },
        },
      },
      tooltip: {
        pointFormat: tooltipPointFormat,
      },
      title: {
        text: title,
      },
      subtitle: {
        text: subtitle,
      },
      series: [
        {
          data,
        },
      ],
    };
  };

  columnChart = (
    filename: string,
    data: any[],
    categories: any[],
    colors: any,
    title: string,
    subtitle: string,
    dataLabelsFormat: string,
    tooltipPointFormat: string,
    isStacked: boolean,
    showLegend: boolean,
    yTitle: string = '',
    plotOptions?: any
  ) => {
    return {
      exporting: {
        filename
      },
      chart: {
        type: "column",
        borderColor: "#ddd",
        borderWidth: 1,
      },
      colors,
      plotOptions: plotOptions || (isStacked
        ? {
          column: {
            stacking: "normal",
            dataLabels: {
              enabled: true,
              format: "{point.y:,.2f}",
            },
          },
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.y:,.2f}",
            },
          },
        }
        : {
          column: {
            dataLabels: {
              enabled: true,
              format: "{point.y}",
            },
          },
          series: {
            dataLabels: {
              enabled: true,
              format: "{point.y}",
            },
          },
        }),
      xAxis: {
        categories,
      },
      yAxis: {
        title: {
          text: yTitle
        }
      },
      stackLabels: {
        enabled: true,
      },
      legend: showLegend
        ? {
          labelFormat: dataLabelsFormat,
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
        }
        : {
          enabled: false,
        },
      title: {
        useHTML: true,
        text: title,
      },
      series: data,
      credits: {
        enabled: false,
      },
      tooltip: {
        pointFormat: tooltipPointFormat,
        shared: true,
      },
    };
  };

  simDataPeriodChart = (filename: string, data: any[]) => {
    const that = this;

    const title ={
      text: ''
    };
    const series = [
      {
        name: that.translate.instant('I18N_SIM.DATA_USAGE'),
        color: "green",
        data: data.map(point => {
          return [point.timestamp, (point.totalUp + point.totalDown) / 1000]
        })
      },
      {
        name: that.translate.instant('I18N_SIM.CUMULATIVE_CURVE'),
        color: "blue",
        data: data.map((point: any, index: number) => {
          return [point.timestamp, data.reduce((acc, usage, currentIdx) => {
            return currentIdx <= index ? acc + (usage.totalUp + usage.totalDown) / 1000 : acc
          }, 0)]
        })
      },
      {
        name: that.translate.instant('I18N_SIM.LIMIT'),
        color: "red",
        data: data.map(point => {
          return [point.timestamp, point.limit]
        })
      }
    ]

    const xAxis = [{
      crosshair: true,
      ordinal: false,
      type: 'datetime'
    }]


    const yAxis = [{
      title: {
        text: this.translate.instant('I18N_SIM.THROUGHPUT')
      },
      labels: {
        formatter: function() {
          return that.decimalPipe.transform(this.value, "1.2-2")
        },
        myunit: "MB"
      },
      opposite: false,
      id: "0",
      maxPadding: 0,
      minPadding: 0,
      min: 0,
    }]

    const formatter = function() {
      if (this.points) {
        const date = new Date(this.x);
  
        let htmlContent = "<div><p><b>" + that.translate.instant('I18N_MONITORING.TIMESTAMP') + "</b> " + that.datePipe.transform(date, 'MMM d') + "</p>";
  
        for (let i = 0; i < this.points.length; i++) {
          const color = this.points[i].series.color;
          const unit = this.points[i].series.yAxis.options.labels.myunit;
          const value = that.decimalPipe.transform(this.points[i].y, "1.2-2");
          let combined = value + " " + unit;
          if (unit == "\u20AC") {
            combined = unit + " " + value
          }
  
          htmlContent += "<span><b> <i class=\"fa fa-minus\" style=\"color:" + color + "\"></i> " + this.points[i].series.name + ": </b>" + combined + "</span><br/>";
        }
        htmlContent += "</div>";
        return htmlContent;
      }
    };

    const calendar = environment && environment.calendar && environment.calendar.locales && environment.calendar.locales[this.translate.currentLang];
    if (calendar) {
      Highcharts.setOptions({
        lang: {
          months: calendar.monthNames,
          shortMonths: calendar.monthNamesShort
        }
      });
    }

    return {
      title,
      exporting: {
        filename
      },
      tooltip: {
        shared: true,
        animation: false,
        shadow: false,
        useHTML: true,
        formatter
      },
      plotOptions: {
        line: {
          marker: {
            enabled: false,
            states: {
              hover: {
                radius: 4,
                lineWidth: 1

              }
            }
          },
          states: {
            hover: {
              lineWidth: 1
            }
          },
          animation: false
        },
        series: {
          animation: false,
          states: {
            hover: {
              lineWidth: 0,
              lineWidthPlus: 0
            }
          }
        }
      },
      xAxis,
      yAxis,
      legend: {
        enabled: true
      },
      series
    }


  }
}
